/* src/app/job-signoff-land-services/pages/job-signoff-land-delete-all-jobs/job-signoff-land-delete-all-jobs.component.scss */
/*# sourceMappingURL=job-signoff-land-delete-all-jobs.component.css.map */
